
<div class="container" style="background: url(../../../assets/img/404.jpg) no-repeat;background-size: cover;height: 80vh; ">
     <div class="row">
          <div class="col-md-12">
          </div>
     </div>
</div>